import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-warning',
  imports: [],
  templateUrl: './warning.component.html',
  styleUrl: './warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningComponent {}
